import { BasicContainer } from '@/components/Common/BasicContainer/BasicContainer';
import FormItem from '@/components/Common/FormItem/FormItem';
import { FormSectionTitle } from '@/components/Form/FormSectionTitle/FormSectionTitle';
import COLORS from '@/constants/colors';
import { FORMAT_DATE_1 } from '@/utils/dateTime';
import {
  Box,
  Button,
  Grid,
  OutlinedInput,
  Stack,
  Typography,
} from '@mui/material';
import {
  DigitalClock,
  MobileDatePicker,
  MobileTimePicker,
} from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { useOrderDeliveryDetailViewController } from './OrderDeliveryDetailViewController';

export const OrderDeliveryDetail = () => {
  const { uiState, actions } = useOrderDeliveryDetailViewController();

  return (
    <Stack spacing="12px" marginTop={'20px'}>
      <FormSectionTitle title="Configuración de Envío" />
      <BasicContainer
        content={
          <Grid container columnSpacing={'16px'} p="16px">
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 500,
                  fontSize: '14px',
                  marginBottom: '10px',
                  color: COLORS.gray_700,
                }}
              >
                Fecha de entrega
              </Typography>
              <FormItem helperText={uiState.deliveryDateError}>
                <MobileDatePicker
                  label={
                    uiState.showPlaceholders ? 'Elegir fecha de entrega' : ''
                  }
                  disabled={!uiState.isEditable}
                  value={uiState.deliveryDate}
                  onChange={actions.onDateChange}
                  minDate={dayjs()}
                  closeOnSelect
                  format={FORMAT_DATE_1}
                  slotProps={{
                    textField: {
                      readOnly: true,
                      fullWidth: true,
                      error: !!uiState.deliveryDateError,
                    },
                  }}
                />
              </FormItem>
            </Grid>
            <Grid size={{ xs: 6, md: 3 }}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 500,
                  fontSize: '14px',
                  marginBottom: '10px',
                  color: COLORS.gray_700,
                }}
              >
                Hora de inicio
              </Typography>
              <FormItem sx={{ marginBottom: '16px' }}>
                <MobileTimePicker
                  label={uiState.showPlaceholders ? 'Hora de inicio' : ''}
                  disabled={!uiState.isEditable}
                  sx={{ width: '100%', color: COLORS.gray_500 }}
                  value={uiState.deliveryStartTime}
                  onChange={actions.onStartTimeChange}
                  closeOnSelect
                  ampm={false}
                  views={['hours']}
                  format="HH:00"
                  viewRenderers={{
                    hours: (props) => <DigitalClock {...props} skipDisabled />,
                  }}
                  minutesStep={60}
                  slotProps={{
                    textField: {
                      readOnly: true,
                    },
                  }}
                />
              </FormItem>
            </Grid>
            <Grid size={{ xs: 6, md: 3 }}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 500,
                  fontSize: '14px',
                  marginBottom: '10px',
                  color: COLORS.gray_700,
                }}
              >
                Hora final
              </Typography>
              <FormItem
                helperText={uiState.deliveryEndTimeError}
                sx={{ marginBottom: '16px' }}
              >
                <MobileTimePicker
                  label={uiState.showPlaceholders ? 'Hora final' : ''}
                  disabled={!uiState.isEditable}
                  sx={{ width: '100%', color: COLORS.gray_500 }}
                  value={uiState.deliveryEndTime}
                  onChange={actions.onEndTimeChange}
                  closeOnSelect
                  ampm={false}
                  views={['hours']}
                  format="HH:00"
                  viewRenderers={{
                    hours: (props) => <DigitalClock {...props} skipDisabled />,
                  }}
                  minutesStep={60}
                  slotProps={{
                    textField: {
                      readOnly: true,
                      error: !!uiState.deliveryEndTimeError,
                    },
                  }}
                />
              </FormItem>
            </Grid>
            <Grid size={12}>
              <OutlinedInput
                disabled={!uiState.isEditable}
                fullWidth
                sx={{
                  '& .MuiOutlinedInput-input::placeholder': {
                    color: COLORS.gray_500,
                    opacity: 1,
                  },
                }}
                placeholder={
                  uiState.showPlaceholders ? 'Agregar notas de entrega' : ''
                }
                value={uiState.deliveryNotes}
                onChange={actions.onNotesChange}
              />
            </Grid>
          </Grid>
        }
        footer={
          uiState.isEditable && (
            <Box sx={{ textAlign: 'right', p: '16px' }}>
              <Button
                variant="contained"
                disabled={uiState.saveDisabled}
                onClick={actions.onSaveChanges}
              >
                Guardar cambios
              </Button>
            </Box>
          )
        }
      />
    </Stack>
  );
};
